<template>
  <div id="Personal">
    <van-button class="loginout" type="info" @click="loginoutFn">退出</van-button>
    <van-tabbar v-model="active" active-color="#177EE5" inactive-color="#000" @change="changetabbar">
      <!-- info="1" -->
      <van-tabbar-item icon="smile-o">聊天对话</van-tabbar-item>
      <van-tabbar-item icon="user">个人中心</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
// import { Toast } from 'vant-green'
// import {WhatsAppChatTelephonesList, WhatsAppCustomerTelephonesList, WhatsAppCustomerTelephonesChatList, WhatsAppTagList} from '../http/api'
export default {
  data () {
    return {
      active: 1
    }
  },
  methods: {
    changetabbar () {
      if (this.active === 0) {
        this.$router.push({path: '/Home'})
      }
    },
    loginoutFn () {
      // localStorage.clear()
      this.$router.push({path: '/login'})
    }
  },
  mounted () {
  }
}
</script>
<style scoped>
  .loginout{width: 80%;margin: 40% auto 0;display: block;}
</style>



// WEBPACK FOOTER //
// src/view/Personal.vue